import CommonModal from "../../../../Modals/commonModal";
import Style from "./DeleteAlbumImageModal.module.scss";
import { useDeleteAlbumImageModal } from "./useDeleteAlbumImageModal";

const DeleteAlbumImageModal = ({ deleteModal, setDeleteModal, albumId }) => {
  const {
    selectedAlbumImage,
    handleDelete,
    albumDetails,
    handleClose,
    isDeletingAlbum,
    isDeletingAll,
  } = useDeleteAlbumImageModal({
    setDeleteModal,
    albumId,
  });
  const DeleteModalContent = () => {
    return (
      <>
        <h3 className={Style.delete_title}>{`Delete ${
          selectedAlbumImage?.selectedImage?.length > 1 ? (albumDetails?.default?"Documents":"Photos") : (albumDetails?.default?"Document":"Photo")
        }`}</h3>
        <p className={Style.delete_content}>
        {albumDetails?.default? `This document will be deleted from the library, it will be in the trash.`:`Remove from Album" keeps it in your library, while "Delete from All"
          moves it to the trash.`}
        </p>
        <div className={`${Style.delete_btn_wrap} `}>
          <button
            className={`${
              isDeletingAll == "loading" && Style.btn_loader
            } ${
              albumDetails?.default ? "btn-danger" : "btn-outline-gray"
            }`}
            onClick={() => handleDelete("permanent")}
          >
            {isDeletingAll !== "loading" ?
            albumDetails?.default? "Delete": " Delete from All" : "Deleting..."}
          </button>

          {!albumDetails?.default &&<button
            className={`${
              albumDetails?.default ? "btn-danger" : "btn-outline-gray"
            } ${isDeletingAlbum == "loading" && Style.btn_loader}`}
            onClick={() => handleDelete("album")}
          >
            {isDeletingAlbum !== "loading"
              ? "Delete from Album"
              : "Deleting..."}
          </button>}
        </div>
      </>
    );
  };

  return (
    <CommonModal
      showModal={deleteModal.popup}
      hide={() => handleClose()}
      className={Style.delete_this_photo_modal}
      title={""}
      content={<DeleteModalContent />}
    />
  );
};

export default DeleteAlbumImageModal;
